import * as React from "react";

import { GlobalsContext } from "kw/util/Globals";
import {
  HeadingLarge,
  LabelMedium,
  ParagraphMedium,
} from "kanopi-components/typography";
import { Block } from "kanopi-components/Block";
import { PortalRow, RowGap } from "kanopi-components/PortalRow";
import { ConfirmationCircle } from "kw/util/ConfirmationCircle";
import { PolicyFixedFooter } from "kw/policies/components/PolicyFixedFooter";
import { NavButton } from "kw/components/NavButton/NavButton";
import { ContactUsModal } from "kw/components/ContactUs/ContactUs";
import { useNavigate } from "@reach/router";

type TClaimSubmissionSuccessPageProps = {
  claimNumber?: string;
};

export const ClaimSubmissionSuccessPage = ({
  claimNumber,
}: TClaimSubmissionSuccessPageProps) => {
  const navigate = useNavigate();
  const gotoClaimsHomeCb = React.useCallback(() => {
    navigate("/claims");
  }, []);

  return (
    <GlobalsContext.Provider value="claims">
      <Block
        display="flex"
        justifyItems="center"
        flexDirection="column"
        alignItems="center"
      >
        <PortalRow>
          <ConfirmationCircle />
        </PortalRow>
        <PortalRow bottomSpace={RowGap.Standard}>
          <Block display="flex" flexDirection="column">
            <LabelMedium center>Claim {claimNumber}</LabelMedium>
            <HeadingLarge center margin={0}>
              Your claim has been submitted
            </HeadingLarge>
          </Block>
        </PortalRow>
        <PortalRow>
          <ParagraphMedium center>
            Thank you for submitting your claim. We&apos;ve sent your claim to the
            insurer.
          </ParagraphMedium>
          <ParagraphMedium center>
            We&apos;ll keep you updated about the status of your claim via email and on
            this portal.
          </ParagraphMedium>
          <ParagraphMedium center>
            You can <ContactUsModal buttonText="contact us" /> if you have any
            questions.
          </ParagraphMedium>
        </PortalRow>
        <PolicyFixedFooter>
          <NavButton onClick={gotoClaimsHomeCb}>Done</NavButton>
        </PolicyFixedFooter>
      </Block>
    </GlobalsContext.Provider>
  );
};
